import { computed, ComputedRef } from 'vue'

import { TeamSide } from '@collector/shared-domain'

import { useEventSettings } from './useEventSettings'

export function useSwitchTeamColors(): {
  isSwitchedTeamColors: ComputedRef<boolean>
  getTeamSideColor(teamSide: TeamSide): TeamSide
} {
  const { eventSettings } = useEventSettings()

  const isSwitchedTeamColors = computed(
    () => eventSettings.value.teamColorsSwitched ?? false,
  )

  function getTeamSideColor(teamSide: TeamSide): TeamSide {
    return isSwitchedTeamColors.value
      ? teamSide === 'home'
        ? 'away'
        : 'home'
      : teamSide
  }

  return {
    isSwitchedTeamColors,
    getTeamSideColor,
  }
}
